// extracted by mini-css-extract-plugin
export default {"productGallery":"fG-z","inQuickShop":"gG-z"};